export default "<div class=\"main\" #main>\n    <p class=\"each-elements\" #paras></p>    \n</div>\n<div #buttonCont ></div>\n\n";